import { compose, createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { createHashHistory } from 'history';
import rootReducers from '../reducers/index';
import rootSaga from '../sagas/index';

const preloadedState = {};

const sagaMiddleware = createSagaMiddleware();
export const history = createHashHistory();

/* Let us know if we are on development or production */
let composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducers(history),
  preloadedState,
  composeEnhancers(
    applyMiddleware(
      sagaMiddleware,
      routerMiddleware(history),
    ),
  )
);

sagaMiddleware.run(rootSaga)


export default store;
